{
  "version": 1,
  "asset_id": "56f1c5ea-81c9-4928-8ba4-d2f6a65b7d08",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/56f1c5ea-81c9-4928-8ba4-d2f6a65b7d08/hiatal-type-2-sleeve-en-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/56f1c5ea-81c9-4928-8ba4-d2f6a65b7d08/hiatal-type-2-sleeve-en-800.jpg",
  "original_filename": "hiatal-type-2-sleeve-en-800.jpg",
  "size": 87366,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T22:45:45Z"
}
